// src/components/ImageUpload.jsx
import React, { useState } from 'react';

const ImageUpload = ({ field, onImagesChange }) => {
  const [images, setImages] = useState([]);
  const [previews, setPreviews] = useState([]);

  // src/components/ImageUpload.jsx
  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const validImages = files.filter(file => file.type.startsWith('image/'));

    const newImages = [...images, ...validImages];
    setImages(newImages);

    // Create previews
    const newPreviews = validImages.map(file => URL.createObjectURL(file));
    setPreviews([...previews, ...newPreviews]);

    // Notify parent with the new images array
    if (onImagesChange) {
      onImagesChange(newImages);  // Send the updated array
    }
  };

  const removeImage = (index) => {
    URL.revokeObjectURL(previews[index]);
    const newImages = images.filter((_, i) => i !== index);
    const newPreviews = previews.filter((_, i) => i !== index);
    setImages(newImages);
    setPreviews(newPreviews);

    // Notify parent with the updated array (empty array if all removed)
    if (onImagesChange) {
      onImagesChange(newImages);
    }
  };



  return (
    <div className="image-upload-container">
      <input
        type="file"
        accept="image/jpeg,image/png,image/gif,image/webp"
        multiple
        onChange={handleImageUpload}
        className="image-input"
        id={`image-input-${field.id}`}
      />

      <label
        htmlFor={`image-input-${field.id}`}
        className="image-upload-label"
      >
        📸 Choose Images
      </label>

      {previews.length > 0 && (
        <div className="image-previews">
          {previews.map((preview, index) => (
            <div key={index} className="image-preview">
              <img src={preview} alt={`Preview ${index + 1}`} />
              <button
                type="button"
                onClick={() => removeImage(index)}
                className="remove-image"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      )}

      <div className="helper-text">
        Upload multiple images. Supported: JPG, PNG, GIF
      </div>
    </div>
  );
};

export default ImageUpload;